<template>
	<div class="addressBar flexDiv">
      	<div v-if="addressBarData.lanmu" class="PColumn">
			  <h3>{{ addressBarData.lanmu.Name }}</h3>
      	</div>
      	<div v-else class="PColumn">
		  <h3>{{ addressBarData.PColumn.Name }}</h3>
		</div>
        <p class="PR">位置：
			<router-link to="./" >首页 >> </router-link>
			<router-link v-if="addressBarData.PColumn" :href="addressBarData.PColumn.Url" :to="addressBarData.PColumn.Url"  @click.native="OpenLink(item.Url)">{{addressBarData.PColumn.Name}} >> </router-link>
			<router-link :to="addressBarData.lanmu.Url"  :href="addressBarData.lanmu.Url"  @click.native="OpenLink(addressBarData.lanmu.Url)" >{{addressBarData.lanmu.Name}}</router-link>
		</p>
    </div>
</template>

<script>
	export default{
		name:'addressBar',
		props:{
			addressBarData:{
				type: Object,
				  default: () => {
					  return {
						PColumn:{},
						lanmu:{},
						List:[]
					  }
				  }
			},
			moreLink: {
			   type: String,
			   default: ''
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
.addressBar{
	width: 1200px;
	height: 42px;
	border-bottom: 1px solid #E6E6E6;
	box-sizing: border-box;
	padding-top: 15px;
	margin-bottom: 40px;
	.PColumn{
		h3{
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 18px;
			letter-spacing: 1px;
			color: #333333;
		}
	}
	.PR{
        font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 18px;
		letter-spacing: 1px;
		color: #333333;
		a{
			font-size: 16px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 18px;
			letter-spacing: 1px;
			color: #333333;
			display: inline-block;
		}
    }
}
</style>



// WEBPACK FOOTER //
// src/components/addressBar.vue